import { Box, Typography } from "@mui/material"
import SupportIcon from "@mui/icons-material/Support"
import { alpha, useTheme } from "@mui/material/styles"

interface NoConversationsProps
{ 
  isAdmin: boolean | undefined
}


export const NoConversations = ({ isAdmin }: NoConversationsProps) =>
{
  const theme = useTheme()
  return(
    <Box sx={styles.container(theme)}>

     { !isAdmin ? <>
      <SupportIcon style={styles.icon} />
      <Typography fontWeight="700" variant="subtitle1" color="textPrimary">Looks like you don't have any open support requests</Typography>
      <Typography variant="body2" color="textSecondary">If you need help with something enter a subject below and press start request</Typography>

      </> :
      <>
        <SupportIcon style={styles.icon} />
        <Typography fontWeight="700" variant="subtitle1" color="textPrimary">It's pretty quite here</Typography>
        <Typography variant="body2" color="textSecondary">No open support requests from customers</Typography>
      </>
      
      } 
    

    </Box>
  )
}

const styles = {
  container: (theme: any) => ({
    justifyContent: 'center' as 'center',
    flex: 1,
    height: "36vh",
    textAlign: 'center' as 'center',
    alignItems: 'center' as 'center',
    flexDirection: "column" as 'column',
    display: 'flex'as 'flex',
    borderRadius: "16px",
    backgroundColor: alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.03 : 0.56),
    border: `1px solid ${alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.06 : 0.4)}`,
  }),
  icon: {
    height: 64,
    width: 64,
    alignSelf: 'center',
    color: "grey"
  }
}
